import { css, jsx } from '@emotion/react';
import { daysFromNow, parseDateTime } from '@zapier/date';
import { Price } from '@zapier/currency';
import { Alert, Link } from '@zapier/design-system';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
import { labelStyles } from '@zapier/style-encapsulation';
import { baseReset } from '../../../../utils/style-mixins/reset';
export const shouldRender = (data) => {
    return data.currentAccount.isTrialingTeams;
};
const Styles = labelStyles('TeamsTrialing', {
    content: css `
    ${baseReset};
  `,
});
export const Component = function TeamsTrialing(props) {
    var _a, _b, _c, _d, _e;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const { data, currency } = props;
    const { currentAccount } = data;
    const willAutoUpgrade = currentAccount.teamsTrialAutoUpgrade;
    const canToggleAutoUpgrade = currentAccount.currentUserRole &&
        ['owner', 'admin', 'super_admin'].includes(currentAccount.currentUserRole);
    const nextPlanAmount = (_b = (_a = data.nextTeamPlan) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : -1;
    const interval = currentAccount.plan.interval;
    const isYearly = interval === 'year';
    const monthlyAmount = isYearly ? nextPlanAmount / 12 : nextPlanAmount;
    const trialDaysRemaining = currentAccount.teamTrialEndDate
        ? daysFromNow(currentAccount.teamTrialEndDate)
        : 0;
    const formattedEndDate = parseDateTime(currentAccount.teamTrialEndDate)
        .toLocaleString('en-US', { month: 'short', day: 'numeric' })
        .replace(/([a-z]+)/i, '$1.');
    const autoBillingLink = (jsx(Link, { href: getFullyQualifiedURL('/app/settings/billing') }, "Edit trial payment settings"));
    const daysText = trialDaysRemaining === 1 ? 'day' : 'days';
    const title = currentAccount.teamTrialEndDate
        ? `${trialDaysRemaining} ${daysText} left in your Team trial`
        : 'You are on a Team trial';
    const intervalText = isYearly ? ' (paid annually)' : '';
    const content = willAutoUpgrade ? (jsx("p", { "data-zds": true, css: Styles.content },
        `You will be billed and charged `,
        monthlyAmount < 0 ? ('') : (jsx("span", { "data-zds": true },
            jsx(Price, { currency: currency }, monthlyAmount),
            "/month",
            intervalText)),
        '. ',
        canToggleAutoUpgrade ? autoBillingLink : null)) : (jsx("p", { "data-zds": true, css: Styles.content },
        (currentAccount.teamTrialEndDate
            ? `On ${formattedEndDate}, `
            : `At the end of your trial, `) +
            `you’ll lose access to Team plan features and be downgraded to a ${(_e = (_d = (_c = data.currentAccount) === null || _c === void 0 ? void 0 : _c.plan) === null || _d === void 0 ? void 0 : _d.type) !== null && _e !== void 0 ? _e : 'Free'} plan. `,
        canToggleAutoUpgrade ? autoBillingLink : null));
    return (jsx(Alert, { variant: props.variant, title: title, status: "info" }, content));
};
//# sourceMappingURL=TeamsTrialing.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
